import { ca } from '@cian/analytics';
import { TE2eLabelTrackingFunction } from '../hooks/useE2eLabelTracking';

export const trackQuestionShow: TE2eLabelTrackingFunction<{ questionName: string }> = ({
  siteType,
  questionName,
  offerStatus,
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Show_deal_label_sopr',
    label: questionName,
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackQuestionAnswerClick: TE2eLabelTrackingFunction<{ questionName: string; answer: string }> = ({
  siteType,
  questionName,
  offerStatus,
  answer,
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Click_deal_label_form_sopr',
    label: `${questionName}/${answer}`,
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackBannerClose: TE2eLabelTrackingFunction = ({ offerStatus, siteType }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Click_deal_label_form_sopr',
    label: 'Close_form',
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackIntroBannerAddLabelClick: TE2eLabelTrackingFunction = ({ offerStatus, siteType }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Show_deal_label_form_sopr',
    label: 'Add_label_old',
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackAddLabelClick: TE2eLabelTrackingFunction = ({ offerStatus, siteType }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Click_deal_label_form_sopr',
    label: 'Add_label_new',
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackChangeAnswerClick: TE2eLabelTrackingFunction<{ questionName: string }> = ({
  offerStatus,
  siteType,
  questionName,
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Click_deal_label_form_sopr',
    label: 'Change_answer',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        type: questionName,
      },
    },
  });
};

export const trackE2eInfoPopupShow: TE2eLabelTrackingFunction = ({ offerStatus, siteType }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Show_deal_label_form_sopr',
    label: 'Popup',
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackLabelAddedScreenShow: TE2eLabelTrackingFunction = ({ offerStatus, siteType }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Show_deal_label_form_sopr',
    label: 'Success',
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};

export const trackRemoveLabelClick: TE2eLabelTrackingFunction = ({ offerStatus, siteType }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Click_deal_label_form_sopr',
    label: 'Remove_label',
    page: {
      pageType: 'AddForm',
      siteType,
    },
  });
};
